import { EasyForm, EasyHtml, EasyMarkdown, EasyCode } from '@q/easy-render';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Skeleton } from 'antd';
import ScrollView from '@/ui/scroll-view';
import planQuestionStore from './store';
import EE from '@/common/event';
import Countdown from './countdown';
import { useMemo } from 'react';
import chatStoreManager from '@/store/chat/manager';
import McpError from '@/components/vnc-viewer/components/error';

const PlanQuestion = observer(props => {
  const {
    className = '',
    countdownClassName = '',
    planData,
    planStepId,
    planed = false,
    requestPlanParams,
    hideTitle = false,
    scene = 'right',
    event,
    data,
  } = props;

  const planRef = useRef(null);
  const [disable, setDisable] = useState(planed);
  const [requested, setRequested] = useState(false);
  const [formRes, setFormRes] = useState(null);
  const [mcpError, setMcpError] = useState(false);
  const [parseSuc, setParseSuc] = useState(false)
  const docRef = useRef(null);
  const [msgCount, setMsgCount] = useState(0);
  const msgCountRef = useRef(null);
  const isLeftScene = scene == 'left';
  const chatStore = chatStoreManager.current;
  const messageItem = chatStore.messageMap.get(requestPlanParams.message_id);
  msgCountRef.current = msgCount;
  useEffect(() => {
    setDisable(planed);
  }, [planed]);

  const memoResult = useMemo(() => {
    return data?.html_result;
  }, [Object.keys(data?.html_result || {})?.length]);

  useEffect(() => {
    const handle = evt => {
      const { data: evtData } = evt;

      if (evtData.action !== 'UICardChange') {
        return;
      }

      if (evtData.data.idx == event.idx) {
        //   if (evtData.data.idx == 1) {
        // 当前卡片消息

        setMsgCount(v => {
          return ++v;
        });
        if (msgCountRef.current == 0) {
          // init value
          planQuestionStore
            .handleAction(evtData.data, 1, requestPlanParams)
            .then(res => {
              if (res?.code == 0) {
              }
            });
        }
        setFormRes(evtData.data);
      }
    };
    window.addEventListener('message', handle);
    return () => {
      window.removeEventListener('message', handle);
    };
  }, []);

  const transformData = html_result => {
    let inputData = {};
    html_result?.form?.forEach(item => {
      inputData[item.key] = item.value;
    });
    return inputData;
  };

  const domParse = (html, formResult) => {
    // 解析 HTML 字符串
    const parser = new DOMParser();
    console.log(decodeURIComponent(escape(atob(html))));
    const doc = parser.parseFromString(
      decodeURIComponent(escape(atob(html))),
      'text/html'
    );
    let formData = {
      idx: event.idx,
    };

    // 创建 script 元素并插入 head
    if (formResult) {
      formData.inputData = transformData(formResult);
      formData.disabled = true;
    }
    const script = document.createElement('script');
    script.textContent = `window.UICardInfo = ${JSON.stringify(formData)}`;
    doc.head.appendChild(script);
    const style = document.createElement('style');
    style.textContent = `body{overflow:hidden;margin:0;}`;
    doc.head.appendChild(style);
    // 转换回字符串并设置 srcdoc
    const updatedHtmlString = new XMLSerializer().serializeToString(doc);
    return updatedHtmlString;
  };

  useEffect(() => {
    let iframe;

    const handleLoad = () => {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      // 计算内容高度（取 body 和 documentElement 的最大值）
      const height = Math.max(
        iframeDoc.body.scrollHeight,
        iframeDoc.documentElement.scrollHeight,
        iframeDoc.body.offsetHeight,
        iframeDoc.documentElement.offsetHeight,
        iframeDoc.body.clientHeight,
        iframeDoc.documentElement.clientHeight
      );
      iframe.style.height = height + 'px';
      console.warn("html加载完成", Date.now())
    };
    let updatedHtmlString;
    console.warn("html消息", Date.now())
    if (data.html_form) {
      try {
        updatedHtmlString = domParse(data.html_form, memoResult);
        setParseSuc(true)
        console.warn("html解析完成", Date.now())
      } catch (e) {
        console.log('error e is', e);
        updatedHtmlString = '';
        setMcpError(true);
      }
      // const updatedHtmlString = domParse(data.html_form, memoResult);
      iframe = document.createElement('iframe');

      iframe.style.cssText = 'width:100%;height: 100%';
      iframe.srcdoc = updatedHtmlString;
      // iframe.setAttribute('id', 'iframe-wrapper');
      docRef.current.appendChild(iframe);
      iframe?.contentWindow?.addEventListener('load', handleLoad);
    }
    return () => {
      // 卸载dom
      // const iframe = document.getElementById('iframe-wrapper');
      iframe?.contentWindow?.removeEventListener('load', handleLoad);
      docRef.current && iframe && docRef.current.removeChild(iframe);
      setMcpError(false);
      setParseSuc(false)
    };
  }, [data.html_form, memoResult]);

  useEffect(() => {
    const timer = setInterval(() => {
      try {
        const $iframe = docRef.current.querySelector('iframe');
        const height = $iframe.contentWindow.document.body.scrollHeight;
        if (height) {
          $iframe.style.height = height + 30 + 'px';
        }
      } catch (e) {}
    }, 300);

    return () => {
      clearInterval(timer);
    };
  }, []);
  console.log('data.html_form', data.html_form);
  if (mcpError || event.status == 'failed') {
    return <McpError></McpError>;
  }

  return (
    <div
      ref={planRef}
      className={['mcp-tools-plan relative', false ? '' : 'pr-4px', className]}
      data-id={planStepId}
      onClick={event => {
        event.stopPropagation();
      }}
    >
      {(!data || !data?.html_form?.length)? (
        <Skeleton className="px-24px" active />
      ) : (
        <>
          <ScrollView
            className={[
              isLeftScene ? '' : 'max-h-[calc(100vh-400px)] pl-24px pr-20px',
            ]}
          >
            <div ref={docRef}></div>
          </ScrollView>
          {data.html_form && parseSuc ? (
            <div
              className={[
                'flex pt-12px mcp-mobile-hidden',
                isLeftScene ? '' : 'pl-24px pr-20px',
              ]}
            >
              <div
                onClick={evt => {
                  if (disable || requested) return;

                  planQuestionStore
                    .handleAction(formRes, 0, requestPlanParams)
                    .then(res => {
                      if (res?.code == 0) {
                        setRequested(true);
                        EE.emit('confirm_countdown_reload');
                      }
                    });
                }}
                className={[
                  'flex-1 h-36px rounded-8px vh-center text-14px font-bold text-black border-1px border-black border-opacity-16 mr-12px',
                  disable || requested
                    ? 'opacity-30'
                    : 'hover:bg-[rgba(0,0,0,0.03)] cursor-pointer',
                ]}
              >
                跳过
              </div>
              <div
                onClick={evt => {
                  if (disable || requested) return;
                  planQuestionStore
                    .handleAction(formRes, 0, requestPlanParams)
                    .then(res => {
                      if (res?.code == 0) {
                        setRequested(true);
                        EE.emit('confirm_countdown_reload');
                      }
                    });
                }}
                className={[
                  'flex-1 h-36px rounded-8px vh-center text-14px font-bold bg-black',
                  disable || requested
                    ? 'bg-opacity-6 text-black text-opacity-50'
                    : 'text-white hover:bg-[#333] cursor-pointer',
                ]}
              >
                确认
                <Countdown
                  planStepId={planStepId}
                  disable={disable || requested}
                  timeout={60}
                  overrun={evt => {
                    planQuestionStore
                      .handleAction(formRes, 0, requestPlanParams)
                      .then(res => {
                        if (res.code == 0) {
                          setRequested(true);
                        }
                      });
                  }}
                />
              </div>
            </div>
          ) : null}

          {/* { (
            <Countdown
              planStepId={planStepId}
              disable={disable || requested}
              timeout={60}
              overrun={evt => {

              }}
              className={[
                'absolute  bottom-0px transform translate-y-[calc(100%+18px+24px)]',
                isLeftScene ? 'left-[-24px]' : 'left-0px',
                countdownClassName,
              ]}
            />
          )} */}
        </>
      )}
    </div>
  );
});
export default PlanQuestion;
